// extracted by mini-css-extract-plugin
export default {"Icon":"f582WMZQ","IconContainer":"Ibzsx838"};